<template>
  <el-form inline class="card-article-content">
    <el-form-item label="文章标题">
      <bean-link keepNode target="_blank" :to="linkTo({ item: value })">{{ value.title }}</bean-link>
    </el-form-item>
    <el-form-item label="类型">
      {{ typeText }}
    </el-form-item>
    <el-form-item label="评论数">
      {{ value.comments_count }}
    </el-form-item>
    <el-form-item label="点赞数">
      {{ value.stars_count }}
    </el-form-item>
    <el-form-item label="分享次数">
      {{ value.shares_count }}
    </el-form-item>
    <el-form-item label="浏览量">
      {{ value.views_count }}
    </el-form-item>
  </el-form>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { linkTo } from '@/custom_columns_extend'

@Component
export default class ArticleCard extends Vue {
  @Prop({ type: Object, default: () => ({}) }) value;

  linkTo = linkTo

  get typeText() {
    return {
      Article: '文章',
      SpecialColumn: '专栏',
      SeekTruthWeekly: '求真周刊',
      SeekTruthVideo: '求真视频',
      BookList: '书单',
      Podcast: '播客',
      YouthCamp: '青训营心得',
      BookClub: '读书会心得'
    }[this.value.type];
  }

}
</script>

<style scoped lang="scss">
  .card-article-content {
    margin-bottom: -22px;
  }
</style>
